import React, { useState, useEffect } from "react";
import { ToastError } from "../../services/ToastMsg";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import {
  FormHelperText,
  Input,
  InputLabel,
  InputBase,
  Button,
} from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Checkbox from "@material-ui/core/Checkbox";
import grey from "@material-ui/core/colors/grey";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import clsx from "clsx";
import transObj from './transformerObj';
import FilterComponents from "../FilterComponents/FilterComponents";
import { FilterComponentObj } from "../FilterComponents/FilterComponentObj";
import { getCookie } from "../../services/Cookies";
const useStyles = makeStyles((theme) => ({
  justifyContentBetween: {
    justifyContent: "space-between!important",
  },
  alignItemsStretch: {
    alignItems: "stretch",
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    // textAlign: "center",
    color: theme.palette.text.secondary,
  },
  gridSpacing: {
    margin: "0 !important",
    width: "100% !important",
  },
  btnFilters: {
    color: "#ff4717",
    border: "1px solid rgb(255 71 23)",
    textTransform: "capitalize",
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight: "8px"
  },
  alignment: {
    alignItems: "center",
  },
}));
const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },

  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "auto",
    padding: "10px 12px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
    "&.Mui-disabled": {
      backgroundColor: "#eee"
    }
  },
}))(InputBase);

const BootstrapDate = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },

  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "100%",
    padding: "10px 12px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
    "&.Mui-disabled": {
      backgroundColor: "#eee"
    }
  },
}))(InputBase);


export default function TransformerForm(props) {
  const classes = useStyles();
  const [filter, setFilter] = React.useState(true);
  const [formObj, setFormObj] = useState(transObj);
  const [filtercomObj, setfiltercomObj] = React.useState(FilterComponentObj);
  const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
  const { getFilterDataByInput, clearFilter } = props;
  const applyFilter = (obj) => {
    //console.log(formObj);
    // getFilterDataByInput(formObj)
    getFilterDataByInput(obj)
  }
  const onClear = () => {
    
    clearFilter();
    setFormObj(transObj)

  }
  const onChangeText = (event) => {
    setFormObj({ ...formObj, [event.target.name]: event.target.value });
    //console.log(formObj);
  };
  const enterKey = (event) => {
    if (event.key === 'Enter') {
      applyFilter()
    } if (event.key === 'Escape') {
      onClear()
    }
  }
  const serialNumberparent = (newValue) => {
    //
    setfiltercomObj({ ...filtercomObj, Totserialnumber: newValue })
  }
  const manufactureParent = (newValue) => {
    setfiltercomObj({ ...filtercomObj, Totmanufacture: newValue })
  }
  const locationparent = (newValue) => {
    //
    setfiltercomObj({ ...filtercomObj, Totlocation: newValue })
  }
  const Voltageparent = (newValue) => {
    //
    setfiltercomObj({ ...filtercomObj, Totvoltage: newValue })
  }
  const defaultValue = (val) => {
    //
    if (val !== "" && val !== undefined && val !== "null") {
      let Obj = JSON.parse(val);
      setfiltercomObj(Obj);
      console.log('getcookievalue', formObj)
    }
  }
  useEffect(() => {
    defaultValue(GlobalFilterSettingValue);

  }, [])
  /* const getLocationDetailsFilter = () => {
    //console.log(formObj);
    if(formObj.location) getFilterDataByInput(formObj);
    else
    ToastError("Location is required");
    // getFilterDataByInput(formObj);
  } */

  return (
    <div>
      <Box className="decarbox1" component="div" style={{padding: "20px"}}  >
  <FilterComponents screen={"assetsToT"} filtervalue={["CustomerName","TransformerName","TotSubCustomer_NameComponent","SerialNumber","Rating","Manufacturer","Location","Voltage","TotUnitDescripitionComponent"]}  applyFilter={applyFilter} reset={onClear} />
  </Box>
      {/* <Box component="div" mt={0} px={1} py={1} display={filter ? "block" : "none"}
      >
        <Box
          component="div"
          display="flex"
          pb={0}
          className={clsx(
            classes.justifyContentBetween,
            classes.alignItemsStretch
          )}

        >
          <Grid container spacing={3}>
            <Grid className="ast-grid" item xs={12} sm={6} md={4} lg={3}>
              <Box
                component="div"
                width={0.2}
                px={1}
                py={1}
                className={classes.borderRight}
                onKeyDown={enterKey}
              >
                <Box
                  component="div"
                  display="flex"
                  className={classes.justifyContentBetween}
                  alignItems="flex-end"
                  height={1}
                >
                  <Box className="filter-col" component="div" width={1} display="block">
                    <Box
                      component="div"
                      display="flex"
                      className="filter-col-in"
                      alignItems="end"
                      pb={1}
                    >
                      <FilterComponents filtervalue={["SerialNumber"]} serialNumberChange={serialNumberparent} />
                    </Box>
                    <Box
                      component="div"
                      display="flex"
                      className="filter-col-in"
                      alignItems="end"
                      pb={1}
                    >
                      <Box component="label"  >
                        Unit description
                      </Box>
                      <Box component="div">
                        <BootstrapInput name="unitDescription"
                          value={formObj.unitDescription}
                          onChange={onChangeText} />
                      </Box>
                    </Box>


                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid className="ast-grid" item xs={12} sm={6} md={4} lg={3}>
              <Box
                component="div"
                width={0.2}
                px={1}
                py={1}
                className={classes.borderRight}
              >
                {/*  <Box
                  component="div"
                  display="flex"
                  className="filter-col-in"
                  pb={1}
                >
                  <Box component="label" color={grey[600]}>
                  Job Number
                  </Box>
                  <Box component="div">
                    <BootstrapInput disabled/>
                  </Box>
                </Box> 

                <Box
                  component="div"
                  display="flex"
                  className="filter-col-in"
                  pb={1}
                >
                  <FilterComponents filtervalue={["Manufacturer"]} manufacture={manufactureParent} />
                </Box>
              </Box>
            </Grid>
            <Grid className="ast-grid" item xs={12} sm={6} md={4} lg={3}>
              <Box
                component="div"
                width={0.2}
                px={1}
                py={1}
                className={classes.borderRight}
              >

                <Box
                  component="div"
                  display="flex"
                  className="filter-col-in"
                  pb={1}
                >
                  <FilterComponents filtervalue={["Location"]} locationChange={locationparent} />
                </Box>
                <Box
                  component="div"
                  display="flex"
                  className="filter-col-in"
                >

                </Box>
              </Box>
            </Grid>
            <Grid className="ast-grid" item xs={12} sm={6} md={4} lg={3}>
              <Box
                component="div"

                className={classes.borderRight}
              >
                <Box
                  component="div"
                  display="flex"
                  className="filter-col-in"

                >
                  <FilterComponents filtervalue={["Voltage"]} VoltageChange={Voltageparent} />
                </Box>
                <Box
                  component="div"
                  display="flex"
                  className="filter-col-in"
                >
                  <FilterComponents filtervalue={["Rating"]} />
                </Box>
              </Box>
            </Grid>

          </Grid>
        </Box>
        <Box component="div" display="flex" ml={1} py={1} justifyContent=" left"  >
          <Button variant="outlined" className={classes.btnStyle2}

            onClick={applyFilter}
          >
            Apply Filters
          </Button>
          <Button variant="outlined" className={classes.btnStyle2}

            onClick={onClear}
          >
            Reset
          </Button>
        </Box>
      </Box> */}
    </div>
  );
}
